







import Vue from 'vue';
import {Component} from "vue-property-decorator";
import DriverPendingReports from "@/components/home/DriverPendingReports.vue";
import DriverNextOrders from "@/components/home/DriverNextOrders.vue";

@Component({
	components: {DriverNextOrders, DriverPendingReports}
})
export default class HomeDriver extends Vue {

	public get userId(): string | null {
		return this.$store.getters['user/userId'];
	}

	private dataChanged(): void {
		// TODO: reload data
	}

}
